// Regras puras de exibição do relatório diário das rotas pelo GPS.
import type { RouteDailyReport, RouteReportStopKind } from '../../types/vehicleTracker';

export const STOP_KIND_INFO: Record<RouteReportStopKind, { label: string; color: string; variant: 'success' | 'info' | 'danger' }> = {
  planned: { label: 'Prevista', color: '#16A34A', variant: 'success' },
  depot: { label: 'Depósito', color: '#2563EB', variant: 'info' },
  unplanned: { label: 'Não prevista', color: '#DC2626', variant: 'danger' },
};

/** Diferença do km rodado sobre o previsto, em %. Sem previsto: null. */
export function kmDeltaPercent(driven: number, planned: number): number | null {
  if (!planned || planned <= 0) return null;
  return Math.round(((driven - planned) / planned) * 100);
}

/** "+18%" / "−5%" / "—". */
export function formatDelta(pct: number | null): string {
  if (pct == null) return '—';
  if (pct > 0) return `+${pct}%`;
  if (pct < 0) return `−${Math.abs(pct)}%`;
  return '0%';
}

/**
 * Gravidade da rota para o selo do cabeçalho: alerta quando há parada não
 * prevista, saída do corredor, entrega sem passagem ou km 25% acima do previsto.
 */
export function routeSeverity(r: Pick<RouteDailyReport, 'unplanned_stops_count' | 'off_corridor' | 'visits_missing' | 'driven_km' | 'planned_km' | 'has_tracker' | 'points'>):
  | 'ok'
  | 'attention'
  | 'no_data' {
  if (!r.has_tracker || r.points.length === 0) return 'no_data';
  const delta = kmDeltaPercent(r.driven_km, r.planned_km);
  if (r.unplanned_stops_count > 0 || r.off_corridor.length > 0 || r.visits_missing > 0 || (delta != null && delta > 25)) return 'attention';
  return 'ok';
}

export const SEVERITY_INFO = {
  ok: { label: 'Sem ocorrências', variant: 'success' as const },
  attention: { label: 'Com ocorrências', variant: 'warning' as const },
  no_data: { label: 'Sem dados de GPS', variant: 'neutral' as const },
};

/** "dd/mm/aaaa" de "aaaa-mm-dd" (sem passar por Date). */
export function formatDateBRFromISO(iso: string): string {
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? `${m[3]}/${m[2]}/${m[1]}` : iso;
}
